/**
 * Утилиты для работы с геометрией в SchemaEditor
 */

/**
 * Нормализация координат из пикселей в [0..1]
 * @param {Array<{x: number, y: number}>} points - Массив точек в пикселях
 * @param {number} imgWidth - Ширина изображения
 * @param {number} imgHeight - Высота изображения
 * @returns {Array<[number, number]>} - Массив точек в нормализованных координатах
 */
export const normalizePoints = (points, imgWidth, imgHeight) => {
  return points.map(p => [p.x / imgWidth, p.y / imgHeight]);
};

/**
 * Денормализация координат из [0..1] в пиксели
 * @param {Array<[number, number]>} polygon - Массив точек в нормализованных координатах
 * @param {number} imgWidth - Ширина изображения
 * @param {number} imgHeight - Высота изображения
 * @returns {Array<{x: number, y: number}>} - Массив точек в пикселях
 */
export const denormalizePoints = (polygon, imgWidth, imgHeight) => {
  return polygon.map(([x, y]) => ({ x: x * imgWidth, y: y * imgHeight }));
};

/**
 * Вычисление центроида (центра масс) полигона
 * @param {Array<{x: number, y: number}>} points - Массив точек
 * @returns {{x: number, y: number}} - Центр полигона
 */
export const getCentroid = (points) => {
  if (!points || points.length === 0) return { x: 0, y: 0 };
  const sum = points.reduce((acc, p) => ({ x: acc.x + p.x, y: acc.y + p.y }), { x: 0, y: 0 });
  const n = points.length;
  return { x: sum.x / n, y: sum.y / n };
};

/**
 * Преобразование дерева в плоский массив
 * @param {Array} nodes - Дерево узлов
 * @param {string|number|null} parentId - ID родительского узла
 * @returns {Array} - Плоский массив с parentId и sortOrder
 */
export const flattenTree = (nodes, parentId = null) => {
  const result = [];
  nodes.forEach((node, index) => {
    const { children, collapsed, ...rest } = node;
    result.push({
      ...rest,
      parentId,
      sortOrder: index + 1
    });
    if (children && children.length > 0) {
      result.push(...flattenTree(children, node.id));
    }
  });
  return result;
};
